<template>
  <div v-if="isWithinCyberDate" class="countdown h-18 w-full bg-black flex flex-row relative justify-center items-center" :style="cssVars">
    <!-- imagen de fondo -->
    <div class="absolute countdow_fondo h-full w-full">
      <img class="h-full w-full object-fill" :src="countdown_desktop" alt="">
    </div>
    <!-- contenedor padre -->
    <div class="contenedor_padre md:w-auto absolute flex flex-row h-[80%] bg-transparent rounded-lg brillo left-0 right-0 mx-2 md:mx-auto md:left-auto md:right-auto">
      <!-- imagen del logo -->
      <div class="absolute left-2 md:left-3 h-full w-[8rem] md:w-[14rem] bg-transparent flex-shrink-0">
        <img class="h-full w-full object-contain" :src="countdown_logo" alt="Enviar" loading="lazy" />
      </div>
      <!-- texto del contador -->
      <div class="fondo_custom bg-BLANCO_LEON rounded-lg h-full flex flex-row justify-center text-BLANCO_LEON items-center pl-[9rem] md:pl-[15rem] pr-2 md:pr-4 gap-1 md:gap-4 flex-1">
        <div class="time-unit flex flex-col text-center leading-none">
          <span class="label text-[0.65rem] md:text-xs text-[#fff]">Días</span>
          <span class="number text-lg md:text-3xl font-bold text-center text-[#fff]">{{ formattedDays }}</span>
        </div>
        <div class="time-unit flex flex-col text-center leading-none">
          <span class="label text-[0.65rem] md:text-xs text-[#fff]">Horas</span>
          <span class="number text-lg md:text-3xl font-bold text-center text-[#fff]">{{ formattedHours }}</span>
        </div>
        <div class="time-unit flex flex-col text-center leading-none">
          <span class="label text-[0.65rem] md:text-xs text-[#fff]">Minutos</span>
          <span class="number text-lg md:text-3xl font-bold text-center text-[#fff]">{{ formattedMinutes }}</span>
        </div>
        <div class="time-unit flex flex-col text-center leading-none">
          <span class="label text-[0.65rem] md:text-xs text-[#fff]">Segundos</span>
          <span class="number text-lg md:text-3xl font-bold text-center text-[#fff]">{{ formattedSeconds }}</span>
        </div>
      </div>
    </div>

  </div>
</template>
  
<script setup>
  import { ref, computed, onMounted, onUnmounted } from "vue";

  const targetDate = ref(new Date());
  const cyberHastaDate = ref(new Date());
  const days = ref(0);
  const hours = ref(0);
  const minutes = ref(0);
  const seconds = ref(0);
  const isWithinCyberDate = ref(false);

  const cssVars = computed(() => ({
    '--fondo-color': countdown_color_fondo.value || '#FFFFFF'
  }));

  
  const countdown_desktop = ref('');
  const countdown_logo = ref('');
  const countdown_mobile = ref('');
  const countdown_color_fondo = ref('');

  const updateCountdown = () => {
    const now = new Date();
    const timeDifference = targetDate.value - now;
  
    if (timeDifference > 0) {
      days.value = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      hours.value = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
      minutes.value = Math.floor((timeDifference / (1000 * 60)) % 60);
      seconds.value = Math.floor((timeDifference / 1000) % 60);
    } else {
      days.value = 0;
      hours.value = 0;
      minutes.value = 0;
      seconds.value = 0;
    }
  };
  
  const formatNumber = (num) => {
    return num < 10 ? `0${num}` : num;
  };
  
  const formattedDays = computed(() => formatNumber(days.value));
  const formattedHours = computed(() => formatNumber(hours.value));
  const formattedMinutes = computed(() => formatNumber(minutes.value));
  const formattedSeconds = computed(() => formatNumber(seconds.value));
  const config = useRuntimeConfig();

  let intervalId;

  const fetchTargetDate = async () => {
    try {
      const response = await $fetch('/api/mantenedores-visuales', {
        query: {
          action: 'countdown',
          alias: config.public.aliasCountdown
        }
      });

      if (response.status === 'success' && response.data) {
        const data = response.data;
        
        countdown_desktop.value = data.url_fondo_countdown_desktop;
        countdown_mobile.value = data.url_fondo_countdown_mobile;
        countdown_logo.value =  data.url_logo_countdown;
        countdown_color_fondo.value = data.fondo_countdown;

        if(data.cyber_activo == "SI"){
          const countdownHasta = data.countdown_hasta;
          const [countdownDate, countdownTime] = countdownHasta.split(' ');
          const [countdownYear, countdownMonth, countdownDay] = countdownDate.split('-').map(Number);
          const [countdownHour, countdownMinute, countdownSecond] = countdownTime.split(':').map(Number);
      
          targetDate.value = new Date(countdownYear, countdownMonth - 1, countdownDay, countdownHour, countdownMinute, countdownSecond);
      
          const cyberHasta = data.cyber_hasta;
          const [cyberDate, cyberTime] = cyberHasta.split(' ');
          const [cyberYear, cyberMonth, cyberDay] = cyberDate.split('-').map(Number);
          const [cyberHour, cyberMinute, cyberSecond] = cyberTime.split(':').map(Number);
      
          cyberHastaDate.value = new Date(cyberYear, cyberMonth - 1, cyberDay, cyberHour, cyberMinute, cyberSecond);
      
          isWithinCyberDate.value = new Date() <= cyberHastaDate.value;
      
          updateCountdown();
        }
      }
    } catch (error) {
      console.error("Error fetching target date:", error);
    }
  };
  
  onMounted(() => {
    fetchTargetDate();
    intervalId = setInterval(updateCountdown, 1000);
  });
  
  onUnmounted(() => {
    clearInterval(intervalId);
  });

  /*
   .brillo {
    -webkit-box-shadow: 0px 0px 12px 0px rgba(0,238,255,0.9);
    -moz-box-shadow: 0px 0px 12px 0px rgba(0,238,255,0.9);
    box-shadow: 0px 0px 12px 0px rgba(0,238,255,0.9);
  }
  */
</script>
  
<style scoped>

  .fondo_custom {
    background-color: var(--fondo-color, #FFFFFF);
  }

 .brillo {
    -webkit-box-shadow: 0px 0px 12px 0px rgba(255, 255, 255, 0.9);
    -moz-box-shadow: 0px 0px 12px 0px rgba(255, 255, 255, 0.9);
    box-shadow: 0px 0px 12px 0px rgba(255, 255, 255, 0.9);
  }

</style>